import { render, staticRenderFns } from "./MemberBase.vue?vue&type=template&id=7bba5048&scoped=true&"
import script from "./MemberBase.vue?vue&type=script&lang=js&"
export * from "./MemberBase.vue?vue&type=script&lang=js&"
import style0 from "./MemberBase.vue?vue&type=style&index=0&id=7bba5048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba5048",
  null
  
)

export default component.exports